var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaeulendiagrammDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "S\\xE4ulendiagramm_Default",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 44 44",
    style: {
      enableBackground: "new 0 0 44 44"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#B3CCDD;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.7,26.8v11.5c0,0.4,0.3,0.7,0.7,0.7h5c0.4,0,0.7-0.3,0.7-0.7v-6.8c-1.1,0-2.2-0.5-3-1.3L13.7,26.8z  M13.7,26.8"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.6,16l-6,6v16.3c0,0.4,0.3,0.7,0.7,0.7h5c0.4,0,0.7-0.3,0.7-0.7V16.4c-0.2-0.1-0.3-0.3-0.4-0.3L37.6,16z  M37.6,16"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.7,31.8v6.5C4.7,38.7,5,39,5.4,39h5c0.4,0,0.7-0.3,0.7-0.7V26.9l-3.6,3.6C6.8,31.3,5.8,31.7,4.7,31.8 L4.7,31.8z M4.7,31.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.6,30.8v7.5c0,0.4,0.3,0.7,0.7,0.7h5c0.4,0,0.7-0.3,0.7-0.7V24.5l-5.7,5.7C23.1,30.4,22.9,30.6,22.6,30.8 L22.6,30.8z M22.6,30.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.7,5.4C41.4,5.1,41.1,5,40.6,5h-0.1c-2.3,0.1-4.7,0.2-7,0.3c-0.3,0-0.7,0-1.1,0.4c-0.1,0.1-0.2,0.2-0.3,0.4 c-0.3,0.7,0.1,1.2,0.4,1.5l0.6,0.6c0.4,0.4,0.8,0.8,1.2,1.2L20.2,23.5l-6.3-6.3c-0.4-0.4-0.9-0.6-1.4-0.6c-0.5,0-1,0.2-1.4,0.6 l-8.4,8.4c-0.8,0.8-0.8,2.1,0,2.9L3,28.8c0.4,0.4,0.9,0.6,1.4,0.6c0.5,0,1-0.2,1.4-0.6l6.6-6.6l6.3,6.3c0.4,0.4,0.9,0.6,1.4,0.6 c0.5,0,1-0.2,1.4-0.6l15.9-15.9l1.8,1.8c0.2,0.2,0.5,0.5,1,0.5c0.2,0,0.4,0,0.6-0.2c0.1-0.1,0.2-0.2,0.3-0.3 c0.4-0.4,0.4-0.8,0.4-1.2c0.1-1.5,0.1-3,0.2-4.5L42,6.5C42,6,41.9,5.7,41.7,5.4L41.7,5.4z M41.7,5.4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaeulendiagrammDefault);
export default __webpack_public_path__ + "static/media/saeulendiagramm-default.dcdfa24671025dbf7d33a1c5fdd5b373.svg";
export { ForwardRef as ReactComponent };